import React from "react";
import { Header } from "../components/Header/Header";
import { Hero } from "../components/Hero/Hero";
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { FadeInOnScroll } from "../components/FadeInOnScoll/FadeInOnScroll";

export const Home: React.FC = () => {
  useIntersectionObserver(".fade-in-element");

  return (
    <section
      id="home"
      className="relative w-full h-screen bg-cover bg-center bg-fixed text-white"
      style={{
        backgroundImage: `url('../img/photo-durand-leludec-daniel.webp')`,
        backgroundColor: "#333",
      }}
      aria-label="Photo du Duo Durand Leludec daniel"
    >
      <div className="absolute inset-0 bg-black/40 z-0" />

      <FadeInOnScroll>
        <div className="relative z-30 fade-in-element">
          <Header />
        </div>
      </FadeInOnScroll>

      <FadeInOnScroll delay={300}>
        <div className="relative z-10 flex items-center justify-center h-[calc(100vh-80px)] fade-in-element">
          <Hero />
        </div>
      </FadeInOnScroll>
    </section>
  );
};
